
import {combineLatest,  filter } from 'rxjs/operators';
import { DepositMethodsEnum } from './../../../../shared/enums/deposit-methods.enum';
import { SuitabilityProfilesEnum } from '@toro/common/shared/enum/suitability/suitability-profiles.enum';
import { getFirstWord, getProfileDisplayName } from '@toro/common/shared/resources/profile.utils';
import { SuitabilityPanelComponent } from '../../components/suitability-panel/suitability-panel.component';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserProfileState } from '@toro/common/shared/state-management/userprofile/userprofile.reducer';
import { Observable } from 'rxjs';
import { SuitabilityProfileModel } from '@toro/common/shared/models/suitability/suitabilityProfile.model';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { Router } from '@angular/router';
import { DialogDepositComponent } from '@hub-workspace/apps/logged-home/src/app/shared/components/dialog-deposit/dialog-deposit.component';
import { formatCBLC } from '@hub-workspace/apps/logged-home/src/app/shared/utils';
import { UserReRegistationService } from '@toro/common/shared/services/re-registration/user-re-registration.service';
import { IReRegistrationMessage } from '@toro/common/shared/interfaces/re-registration/re-resgistration.interface';
import { ModalComponent } from '@toro/common/shared/components/modal/modal.component';
import { PixDepositService } from '../../../../shared/services/pix-deposit/pix-deposit.service';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';
import { isCnpj } from '@toro/common/shared/helpers/utils/document';

enum PixButtonState {
  Loading,
  Visible,
  Hidden
}
@Component({
    selector: "opened-account-trader",
    templateUrl: "./opened-account-trader.component.html",
    styleUrls: ["./opened-account-trader.component.scss"],
    providers: [],
})
export class OpenedAccountTraderComponent implements OnInit {
    @ViewChild("modalUserRegister", { static: true })
    public modalUserRegister: ModalComponent;
    public currentItem: number = 0;
    public maxItems: number = 0;
    public user$: Observable<UserProfileState>;
    public user: any;
    public greetingName: string;
    public suitability: SuitabilityProfileModel = new SuitabilityProfileModel();
    public suitabilityEnum = SuitabilityProfilesEnum;
    public depositMethodsEnum = DepositMethodsEnum;
    public authentication$: Observable<UsersState>;
    public countBullet: number;
    public userAuth: any;
    public isPJRepresentation: boolean;
    public accessedByName: string;
    public loggedFullName: string;

    public modalUserReRegistration: IReRegistrationMessage;


    public availablePlatformsAndCourses: any[] = [
        {
            iconPath: "home/assets/svg-icons/hat_icon.svg",
            title: "Curso Grátis: Day Trade para iniciantes",
            text: "Aprenda tudo o que precisa para começar a operar na Bolsa de Valores.",
            url: "/lp-curso-daytrade-iniciantes",
            element: 'Card curso Day Trade',
            group: 'Não se aplica'
        },
        {
            iconPath: `home/assets/svg-icons/${environment.isNewBrand ? 'santander': 'toro'}_icon.svg`,
            title: "Descubra o Profit Toro Trader",
            text: "A experiência completa para operar Day Trade em uma só plataforma.",
            url: "/lp-toro-trader",
            element: 'Card plataforma',
            group: 'Profit Toro Trader'
        },
        {
            iconPath: "home/assets/svg-icons/nelogica_icon.svg",
            title: "Conheça o Profit Pro",
            text: "Funcionalidades avançadas para os traders mais experientes.",
            url: "/lp-profit-pro",
            element: 'Card plataforma',
            group: 'Profit Pro'
        },
    ];

    pixButtonState: PixButtonState;

    constructor(
        private store: Store<any>,
        private dialogService: DialogsService,
        private renderer: Renderer2,
        private router: Router,
        private userReRegistationService: UserReRegistationService,
        private pixDepositService: PixDepositService
    ) {
        this.authentication$ = this.store.select(
            (state) => state.authentication
        );

        this.countBullet = Math.ceil(this.availablePlatformsAndCourses.length % 2);

        this.authentication$
            .pipe(filter((data) => !!data.currentUser))
            .subscribe((data) => {
                if (data.currentUser === null) return;
                this.userAuth = { ...data };

                this.userAuth.currentUser.cblc = formatCBLC(
                    this.userAuth.currentUser.cblc
                );
                this.loggedFullName = (this.userAuth.currentUser && this.userAuth.currentUser.name) || '';
                this.updateRepresentation();
            });

        this.pixButtonState = PixButtonState.Loading;
        this.checkPixEnabled();
    }

    private updateRepresentation(): void {
        const user: any = this.user;
        if (!user) return;
        this.isPJRepresentation = user.isRepresentation === true;

        if (this.isPJRepresentation) {
            this.accessedByName = getFirstWord(user.representativeName || this.loggedFullName);
        }
    }

    public ngOnInit() {
        this.sendTracking("Page Loaded", {
            Status: "Conta aberta",
            'Product Area Origin': 'Conta aberta trader',
            'Time Responsável': "Brooklyn Dumbo",
        });
        this.store
            .select(({ userProfile }) => userProfile.user).pipe(
            combineLatest(this.store.select(({ suitability }) => suitability)),
            filter(
                ([{ profile }, suitability]) =>
                    !!profile && !!suitability.profile
            ),)
            .subscribe(([user, { profile }]) => {
                this.user = user;
                this.suitability.profile = profile.profile;

                this.greetingName = getFirstWord(getProfileDisplayName(user));

                this.updateRepresentation();
            });
        this.maxItems = this.availablePlatformsAndCourses.length;
        this.handlerMouseEvents();
        this.getUserRegistrationStore();
    }

    public navigateTo(path: string, element: string, group: string) {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': 'Conta aberta trader',
            'Time Responsável': "Brooklyn Dumbo",
            'Element': element,
            'Group': group
        });
        this.router.navigate([path]);
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    public changeProfile() {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': 'Conta aberta trader',
            'Time Responsável': "Brooklyn Dumbo",
            'Element': 'Card perfil',
            'Group': 'Não se aplica'
        });
        this.show();
        this.dialogService.showComponentAsAsidePanel(
            SuitabilityPanelComponent,
            true,
            {
                data: this.getSuitabilityName(),
            }
        );
    }

    public show() {
        this.renderer.addClass(document.body, "overflow--hidden");
        window.scrollTo(0, 0);
    }

    public showSuitabilityProfileSession() {
        if (this.suitability.profile == SuitabilityProfilesEnum.Bold
            || this.suitability.profile == SuitabilityProfilesEnum.NoProfile) {
            return false;
        } else return true;
    }

    public getSuitabilityName() {
        switch (this.suitability.profile) {
            case SuitabilityProfilesEnum.Conservative:
                return "Conservador";
            case SuitabilityProfilesEnum.Moderate:
                return "Moderado";
            case SuitabilityProfilesEnum.Bold:
                return "Arrojado";
        }
    }

    public handlerMouseEvents() {
        const slider: HTMLElement = document.querySelector('.items');
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e: MouseEvent) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
    }

    public openDepositModal(depositCategory: string) {
        const changeUser = {
            user: this.user
        }

        this.dialogService.showComponentAsAsidePanel(
            DialogDepositComponent,
            true,
            {
                category: depositCategory,
                user: changeUser,
                userAuth: this.userAuth,
            }
        );

        if (depositCategory === DepositMethodsEnum.Pix) {
            this.sendTracking("Element Clicked", {
                'Product Area Origin': 'Conta aberta trader',
                'Time Responsável': "Roebling",
                'Element': 'Botão depósito via Pix',
                'Text': 'Depósito via Pix Copia e Cola',
            });
        } else if(depositCategory === DepositMethodsEnum.Ted) {
            this.sendTracking("Element Clicked", {
                'Product Area Origin': 'Conta aberta trader',
                'Time Responsável': "Roebling",
                'Element': 'Botão depósito via TED',
                'Text': 'Depósito via TED',
            });
        }
    }

    public showUserAccount() {
        if (!this.user || !this.userAuth) return false;

        return this.user.cpfcnpj && this.userAuth.currentUser.cblc;
    }

    /**Indica se a conta logada e Pessoa Juridica (documento com mais de 11 digitos = CNPJ)
     */
    public get isPj(): boolean {
        return isCnpj(this.user && this.user.cpfcnpj);
    }

    /**
     * 
     * Busca os registros status do usuário
     */
    private getUserRegistrationStore() {
      this.store
        .select(({ userProfile }) => userProfile)
        //   .pipe(take(2))
        .subscribe((up) => {
          if (!up.user || !+up.user.registrationStatus) {
            return;
          }
          this.verifyUserReRegister(+up.user.registrationStatus);
        });
    }

    /**
     * verifica se usuário esta expirado
     * Expired = 15
     * PreExpirado = 18
     */
    private verifyUserReRegister(registrationStatus: number) {
      const userExpired = this.userReRegistationService.validateUserExpired(
        registrationStatus
      );
      if (userExpired) {
        this.modalUserReRegistration = userExpired;
        this.modalUserRegister.show();
        return;
      }

      const userPreExpired = this.userReRegistationService.validateUserPreExpired(
        registrationStatus
      );
      if (userPreExpired) {
        this.modalUserReRegistration = userPreExpired;
        this.modalUserRegister.show();
        return;
      }
    }

    public checkPixEnabled() {
      this.pixDepositService
        .getDepositByPixEnabled()
        .then(remoteConfigValue => {
          this.pixButtonState = remoteConfigValue
            ? PixButtonState.Visible
            : PixButtonState.Hidden;
        })
        .catch(err => {
          console.error(err);
          this.pixButtonState = PixButtonState.Hidden;
        });
    }

    public isPixLoading() {
      return this.pixButtonState == PixButtonState.Loading;
    }

    public isPixVisible() {
      return this.pixButtonState == PixButtonState.Visible && !this.isPj;
    }

    public isPixEnabled() {
      return this.isPixVisible() && this.showUserAccount();
    }
}
